export default {
  deleteTitle: 'Invoice Payment',
  overviewTitle: 'Invoice Payments',
  overviewRouterUrl: 'invoicepayments',
  getFilterName (context) { return 'invoicepayments' },
  overviewApiUrl: '/invoice_payments/',
  detailTitle: 'Invoice Payment Detail',
  detailRouterUrl: 'invoicepayment',
  detailApiUrl: '/invoice_payments/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  updateNewRecord (context, rec) {
    if (context.$route.query) Object.assign(rec, context.$route.query)
    rec.commission = 0
  },
  sortOrder: [
    {
      field: 'number',
      sortField: 'number',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Payment ID', name: 'id', sortField: 'id', link: '#/invoicepayment/{id}'},
    {title: 'Invoice Number', name: 'invoice', sortField: 'invoice', link: '#/invoice/numbered/{invoice_id}'},
    {title: 'Contract', name: 'contract', sortField: 'contract.name'},
    {title: 'Student Name', name: 'student_name'},
    {title: 'Net Amount', name: 'net_amount', sortField: 'net_amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Commission', name: 'commission', sortField: 'commission', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Amount Paid', name: 'amount_paid', sortField: 'amount_paid', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Payment Date', name: 'payment_date', sortField: 'payment_date', callback: 'formatDate'},
    {title: 'Payment Confirmation', name: 'payment_confirmation_timestamp', sortField: 'payment_confirmation_timestamp', callback: 'formatTimeStamp'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}
// {
//       "amount_paid": 473.0,
//       "comments": "",
//       "commission": 0.0,
//       "contract": "2017-01-22744",
//       "creation_timestamp": "2017-08-12T12:59:18.644388Z",
//       "creation_user": "Site Admin",
//       "creation_userid": 1,
//       "edit_timestamp": "2017-08-12T12:59:18.644399Z",
//       "edit_user": "Site Admin",
//       "edit_userid": 1,
//       "id": 1,
//       "invoice": "2017SELECT-22744-01",
//       "invoice_id": 8,
//       "net_amount": 473.0,
//       "payment_confirmation_timestamp": null,
//       "payment_confirmation_userid": null,
//       "pdf_creation_timestamp": null,
//       "pdf_creation_userid": null,
//       "pdf_filename": null,
//       "student_name": "Sohail Abubakar"
//     }



// WEBPACK FOOTER //
// ./src/views/InvoicePayment/FieldDefs.js